import * as React from 'react'
import { useCallback, useEffect } from 'react'
import { useFormikContext } from 'formik'

import type { LocAndSvcsFormModel } from '../../formConfig'
import { useLeadScheduleAutoClose } from '../../../hooks/useLeadScheduleAutoClose'

export function useData() {
  const {
    enabled,
    willAutoClose,
    requiredFieldsAreMissing,
    missingScheduleAutoCloseRequiredFields,
  } = useLeadScheduleAutoClose()

  const {
    setFieldValue,
    values: { closeWin: value },
  } = useFormikContext<LocAndSvcsFormModel>()

  useEffect(() => {
    if (enabled && !willAutoClose) {
      setFieldValue('closeWin', 'open')
    }
  }, [enabled, willAutoClose, setFieldValue])

  const onChange = useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>, next: string) =>
      setFieldValue('closeWin', next),
    [setFieldValue],
  )

  return {
    value,
    onChange,
    enabled,
    willAutoClose,
    requiredFieldsAreMissing,
    missingScheduleAutoCloseRequiredFields,
  }
}
